import { Box, Flex, Skeleton } from '@chakra-ui/react';

export const CardPromoInfoSkeleton = () => (
  <Box borderRadius="8px" overflow="hidden">
    <Box
      px={4}
      py={2}
      bgColor="#007AFF"
      display="flex"
      gap="2"
      justifyContent="space-between"
      alignItems="center"
    >
      <Skeleton
        height="4"
        width="20"
        startColor="blue.400"
        endColor="blue.500"
      />
      <Skeleton
        height="4"
        width="24"
        startColor="blue.400"
        endColor="blue.500"
      />
    </Box>
    <Box px={4} py={2} bgColor="#F5F5F5" borderBottomRadius="8px">
      <Flex gap="2" align="center" flex="1">
        <Skeleton height="48px" width="48px" borderRadius="md" />
        <Box flex="1">
          <Skeleton height="3" width="70%" mb="2" />
          <Skeleton height="3" width="50%" />
        </Box>
      </Flex>
    </Box>
  </Box>
);
